import createCrudModule from '@/utils/createCrudModule'

export default createCrudModule({
  resource: 'paymentSubscriptions',
  urlRoot: '/payment_subscriptions'
})
